import React from "react";
import classes from "./OurProjects.module.scss";
import ProjectItem from "./ProjectItem.tsx";
import { useTranslation } from "react-i18next";

export interface IProject {
  id: number;
  imageUrl: string;
  title: string;
  description: string;
  path: string | null;
  isStartup?: boolean;
}

export const SCROLL_CONFIG = {
  smooth: false,
  offset: 0,
  duration: 800,
};


const OurProjects = ({ projects }) => {
  const { t } = useTranslation();

  const getImageUrl = (imagePath) => {
    return imagePath;
  };

  return (
    <div className={classes["portfolio-container"]} id='our-projects'>
      <div className={classes["projects-column"]}>
        <div className={classes["heading-container"]}>
          <div className={classes["title-container"]}>
            <h2 className={classes["portfolio-header"]}>
              {t("ourProjects.title")}
            </h2>
          </div>
        </div>
        <div className={classes["items-container"]}>
          {projects.left.map((project) => (
            <ProjectItem
              key={project.id}
              title={project.title}
              description={project.text}
              imgUrl={getImageUrl(project.image)}
              path={project.path}
              isStartup={project.isStartup}
            />
          ))}
        </div>
      </div>

      <div className={classes["projects-column"]}>
        <div className={classes["items-container"]}>
          {projects.right.map((project) => (
            <ProjectItem
              key={project.id}
              title={project.title}
              description={project.text}
              imgUrl={getImageUrl(project.image)}
              path={project.path}
              isStartup={project.isStartup}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurProjects;
